<template>
  <div class="ml-3 mt-3" style="width:970px">
	<div class="mb-2">
            <el-form inline ref="form" :model="searchform">
        
        <el-form-item class="mb-0">
             <el-select v-model="searchform.value"  :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:100px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
                

                    <el-form-item class="mb-0">
                         <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:120px;"></el-input>
                    </el-form-item>
                    <el-form-item  class="mb-0">
                         <el-date-picker
                              v-model="searchform.time"
                              type="daterange"
                              range-separator="~"
                              :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')"  size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item class="mb-0">
                        <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
                    </el-form-item>
            </el-form>
       
         
        
            
            
        </div>
	<div class="d-flex align-items-center">	
         
           <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
		<el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
        <span class="text-danger ml-2"><b>*비번10회이상오류시 IP차단.오류기록을 삭제하셔야 다시시도가능</b></span>
           
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
       class="mt-2" @selection-change="handleSelectionChange"   :empty-text="$t('tableText.데이타가없습니다')" >
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
       <el-table-column
		   align="center"
			prop="mem_id" 
            :label="$t('nav.아이디')">
			<template slot-scope="scope">
            
             <span @click="openModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
          </template>
			
		  </el-table-column>
           
             <el-table-column
           align="center"
            prop="pwd"
            :label="$t('newAdd.입력비번')">
            
          </el-table-column>

          <el-table-column
           align="center"
            prop="ip"
            label="IP"
            min-width="170">
            <template slot-scope="scope">
              <span>{{scope.row.ip}}</span>
              <el-button
                v-if="!isBlocked(scope.row.ip)"
                type="danger"
                plain
                size="mini"
                class="ml-1 ip-action-btn"
                :loading="blockingIp === scope.row.ip"
                :disabled="!scope.row.ip || blockingIp !== ''"
                @click="blockIp(scope.row)">IP차단</el-button>
              <el-button
                v-else
                type="primary"
                plain
                size="mini"
                class="ml-1 ip-action-btn"
                :loading="unblockingIp === scope.row.ip"
                :disabled="blockingIp !== '' || unblockingIp !== '' || !blockedIps[scope.row.ip].bidx"
                @click="unblockIp(scope.row)">IP해재</el-button>
            </template>
          </el-table-column>

           <el-table-column
           align="center"
            prop="domain"
            :label="$t('nav.도메인')">
            
          </el-table-column>
           <el-table-column
        :label="$t('tableText.시간')"
        prop="create_time" align="center">
      </el-table-column>
    
            <el-table-column
           align="center"
            prop="admin_id" v-if="this.userid=='admin'"
            label="admin-id">
            
          </el-table-column>

     
     <!--  <el-table-column
			prop="contents"
             :label="$t('msg.내용')">
			 <template slot-scope="scope">
            	<el-input
					  type="textarea"
					  :rows="2"
					  v-model="scope.row.contents">
					</el-input>
        	</template>
		  </el-table-column> -->
		  
		  
		 


	
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                     <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 0px;right: 0;z-index: 100;"> 
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
					
				</el-footer>
				

			
</div>
 </template>

 <script>
 import layer from './layer.vue';
import layerNew from './layer-new.vue';
    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{  
                searchform:{
                    keyword:'',
                    time:[],
                    searchOptions:[
                
                    {
                    label:this.$i18n.t("nav.아이디"),
                    value:'mem_id'
                },
                 {
                    label:this.$i18n.t("tableText.아이피"),
                    value:'ip'
                },
                {
                    label:this.$i18n.t("msg.알본"),
                    value:'admin_id'
                },
            

                ],
               
            
                value:'',
          


                },  
                otp:'',
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
            aid:window.sessionStorage.getItem('admin_id'),
    			formLoading:false,
          idDialogVisible: false,
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
    			currentPage:1,
				multipleSelection:[],
				blockingIp:'',
				unblockingIp:'',
				blockedIps:{},
			   
   
    			}
	
    		},
    		created() {
    			this.getList();
				this.getBlockedIps();

		},
    	
    	methods:{
    		  // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
        isBlocked(ip){
          return !!(ip && this.blockedIps[ip]);
        },
        getBlockedIps(){
          let token=window.sessionStorage.getItem('user');
          this.$axios({
            method:'get',
            url:this.domain+'/admin/blist?page=1&limit=10000',
            'Accept':'application/json',
            headers:{ 'Authorization':'Bearer ' + token }
          }).then((response) => {
            let result=response.data && response.data.data;
            let list=result && result.data ? result.data : [];
            let blocked={};
            list.forEach((item) => {
              if(item.ip){
                blocked[item.ip]=item;
              }
            });
            this.blockedIps=blocked;
          }).catch(() => {
            this.blockedIps={};
          });
        },
        blockIp(row){
          if(!row.ip || this.blockingIp || this.isBlocked(row.ip)){
            return;
          }

          this.$confirm(row.ip + ' IP차단 하시겠습니까?', '알림', {
            confirmButtonText:'IP차단',
            cancelButtonText:'취소',
            type:'warning'
          }).then(() => {
            let token=window.sessionStorage.getItem('user');
            this.blockingIp = row.ip;

            this.$axios({
              method:'post',
              url:this.domain+'/admin/b_insert',
              data:{
                ip:row.ip,
                memo:'로그인오류' + (row.mem_id ? ' - ' + row.mem_id : '')
              },
              'Accept':'application/json',
              headers:{ 'Authorization':'Bearer ' + token }
            }).then((response) => {
              this.$message({
                message:response.data.msg,
                type:response.data.code==200 ? 'success' : 'warning'
              });
              if(response.data.code==200){
                this.blockedIps=Object.assign({}, this.blockedIps, { [row.ip]:{ ip:row.ip } });
                this.getBlockedIps();
              }else{
                this.getBlockedIps();
              }
              this.blockingIp = '';
            }).catch((error) => {
              this.blockingIp = '';
              this.$message.error(error.response && error.response.data && error.response.data.msg
                ? error.response.data.msg
                : 'IP차단 실패했습니다.');
            });
          }).catch(() => {});
        },
        unblockIp(row){
          let blocked=this.blockedIps[row.ip];
          if(!blocked || !blocked.bidx || this.blockingIp || this.unblockingIp){
            return;
          }

          this.$confirm(row.ip + ' IP해재 하시겠습니까?', '알림', {
            confirmButtonText:'IP해재',
            cancelButtonText:'취소',
            type:'warning'
          }).then(() => {
            let token=window.sessionStorage.getItem('user');
            this.unblockingIp=row.ip;

            this.$axios({
              method:'post',
              url:this.domain+'/admin/b_up?bidx='+blocked.bidx,
              'Accept':'application/json',
              headers:{ 'Authorization':'Bearer ' + token }
            }).then((response) => {
              this.$message({
                message:response.data.msg,
                type:response.data.code==200 ? 'success' : 'warning'
              });
              if(response.data.code==200){
                let blockedIps=Object.assign({}, this.blockedIps);
                delete blockedIps[row.ip];
                this.blockedIps=blockedIps;
              }else{
                this.getBlockedIps();
              }
              this.unblockingIp='';
            }).catch((error) => {
              this.unblockingIp='';
              this.$message.error(error.response && error.response.data && error.response.data.msg
                ? error.response.data.msg
                : 'IP해재 실패했습니다.');
            });
          }).catch(() => {});
        },
         openModel(id){

            if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }

         this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
                    searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                     this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                     return;
                }

              
            


                this.getList();
                
             

            },
			     
    		getList(){

    		   let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/loginelist?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
    			
    		
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data.data)
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	

               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    		
    		
    		
    		
    		handleSelectionChange(val) {
    			//console.log(val)
                this.multipleSelection = val;

      },
    	  // 批量删除
			deleteAll(){
				 this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					//console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	console.log('id',item);
					 	newids.push(item.id);
					 });

					// console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/logine_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
/deep/ .el-dialog__body{
  padding:10px 20px
 }
 .ip-action-btn{
  padding:4px 6px;
  font-size:11px;
 }

</style>



// WEBPACK FOOTER //
// src/components/common/loginelist.vue